const styles = theme => ({
  templateBox : {
    maxHeight: "10vh",
    maxWidth: "50vw",
    padding : "10px",
    border :"1px solid #eee"
  }
});

export default styles;